import dayjs from "dayjs";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsAccessibility from "highcharts/modules/accessibility";
import HighchartsSankey from "highcharts/modules/sankey";
HighchartsExporting(Highcharts);
HighchartsAccessibility(Highcharts);
HighchartsSankey(Highcharts);

const BarChartGraph = ({ data, startTime, endTime, datePickerType }) => {
  const startDate = dayjs(startTime);
  
  let start, end, axisDateFormat, tooltipDateFormat, graphData=[];
  if(datePickerType === 'day'){
    start = dayjs(startDate).format("D-MMM HH:mm");
    end = dayjs(endTime).format("D-MMM HH:mm");
    axisDateFormat = 'HH';
    tooltipDateFormat = 'HH:mm A';
    graphData = data.map(
      (value) => [dayjs(value.to).format(axisDateFormat), value.totalDistance]
    );
  }else if (datePickerType === 'week'){
    start = dayjs(startTime).format("D-MMM-YYYY");
    end = dayjs(endTime).format("D-MMM-YYYY");
    axisDateFormat = 'D-MMM';
    tooltipDateFormat = 'D-MMM';
    graphData = data.map(
      (value) => [dayjs(value.from).format(axisDateFormat), value.totalDistance]
    );
  } else {
    start = dayjs(startDate).format("D-MMM-YYYY");
    end =  dayjs(endTime).format("D-MMM-YYYY");
    axisDateFormat = 'D';
    tooltipDateFormat = 'D-MMM';
    graphData = data.map(
      (value) => [dayjs(value.from).format(axisDateFormat), value.totalDistance]
    );
  }

  const getOptions = {
    chart: {
      type: "column",
      height: 400,
    },
    title: {
      text: "",
    },
    exporting: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      backgroundColor: "#fafafa",
      borderWidth: 0,
      height: 80,
      padding: 6,
      className: "",
      valueSuffix: '',
        useHTML: true,
        formatter: function () {
        return `<div class="text-center"> 
        <div class="mb05 bold">
        ${dayjs(data[this.point.index].from).format(tooltipDateFormat)} -
        ${dayjs(data[this.point.index].to).format(tooltipDateFormat)}
        </div><b>${this.y}km</b></div>`
      }
    },
    series: [
      {
        dataLabels: {
          enabled: false,
          rotation: -90,
          color: "#FFFFFF",
          inside: true,
          verticalAlign: "top",
          format: "{point.y:.1f}",
          y: 10,
          style: {
            fontSize: "13px",
            fontFamily: "Verdana, sans-serif",
          },
        },
        size: "95%",
        data: graphData,
      },
    ],
    credits: {
      enabled: false,
    },
    colors: ["#5b8fe0"],
    xAxis: {
      type: "category",
      title: {
        text: `<div class="flex-between f12 w100"><div>${start}</div> <div>${end}</div> </div>`,
        useHTML: true,
      },
      className: "distance-xaxis w100",
      uniqueNames: false,
      width: "100%",
      labels: {
        style: {
          fontSize: "13px",
          fontFamily: "Verdana, sans-serif",
        },
        useHTML: true,
        format: '<div class="bar-chart-xaxis-lable">{value}</div>'
      },
    },
    yAxis: {
      title: {
        text: "Distance (km)",
      },
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={getOptions} />;
};

export default BarChartGraph;
